import Component from '../inherited/Component'
import Helpers from '../lib/Helpers'

export default class boostcommerce extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
  }

  mount () {
    let target = document.querySelector(option.selector);
    console.log('working')
    click();
  }

  click(option) {
    let __test = document.querySelector('.boost-pfs-filter-option-title')
    let target1 = document.querySelector('.boost-pfs-filter-option-title')

    __test.addEventListener(onclick, async e => {
      e.preventDefault()
      target1.classList.add('open')
    
    })
  }

}